export default "__VITE_ASSET__DPLBgMkk__"